import React from 'react';
import { TextField, MaskedTextField } from '@fluentui/react';

const ArcTextField = (props) => {

    const valueChangeHandler = (event, value) => {

        const maxValue = isNaN(parseInt(props.config.Max)) ? 100000 : Number(props.config.Max);
        value = value.length > maxValue ? value.substring(0,maxValue) : value;
        value = value.replace(/[|'"]/g, '');
        value = value.replace(/\\/g, '');
        props.changeHandler(props.config.Id, value);
    }

    const focusOutEventHandler = () => {

        let value = props.config.value;
        if  ( props.config.Mask !== undefined && props.config.Mask !== "") {
            if (value !== undefined) {
                let lastChar = value[value.length -1];
                while (value.length > 0 && lastChar === "_") {
                    value = value.slice(0,-1);
                    lastChar = value[value.length -1];
                }
            }
        }
        props.changeHandler(props.config.Id, props.config.value);

        if (props.focusOut !== undefined) {
            props.focusOut(props.config.Id, props.config.value);
        }
    }

    const onKeyDown = () => {
        const x = 1;
    }

    const label = props.config.Label;

    let textField = "";
    if (props.config.Mask === undefined || props.config.Mask === "") {
        textField = <TextField
                        onKeyDown={props.onKeyDown}
                        id={props.config.Id}
                        label={label}
                        autoComplete="off"
                        required={props.config.Required}
                        placeholder={props.config.Placeholder}
                        onChange={valueChangeHandler}
                        value={props.config.value}  
                        onNotifyValidationResult={focusOutEventHandler}
                        validateOnFocusOut={true}
                        tabIndex={props.config.TabIndex !== undefined ? props.config.TabIndex : 0}
                    />
    } else {
        const currentValue = props.config.value === undefined ? props.config.value : props.config.value.toString();
        textField = <MaskedTextField
                        id={props.config.Id}
                        onKeyDown={props.onKeyDown}
                        label={label}
                        autoComplete="off"
                        required={props.config.Required}
                        placeholder={props.config.Placeholder}
                        onChange={valueChangeHandler}
                        value={currentValue}
                        onNotifyValidationResult={focusOutEventHandler}
                        validateOnFocusOut={true}
                        mask={props.config.Mask}
                        maskChar=" "
                        tabIndex={props.config.TabIndex !== undefined ? props.config.TabIndex : 0}
                    />        
    }

    return (
        <React.Fragment>
            {textField}
        </React.Fragment>
    )
}

export default ArcTextField;